type localesKeys__TopNavStats = {
  menuStats__projects: string;
  menuStats__projectsHint: string;
  menuStats__reports: string;
  menuStats__reportsHint: string;
  menuStats__experience: string;
};

const ruLocale__TopNavStats: localesKeys__TopNavStats = {
  menuStats__projects: "Проектов: 25+",
  menuStats__projectsHint:
    "25 — это полноценные проекты. А «+» — всевозможная мелочь, которая считается проектами лишь номинально.",
  menuStats__reports: "Подчиненных:",
  menuStats__reportsHint:
    "18 — сколько всего человек работало под моим руководством за карьеру. 9 — максимум одновременно.",
  menuStats__experience: "Стаж: 14 лет",
};

const enLocale__TopNavStats: localesKeys__TopNavStats = {
  menuStats__projects: "Projects: 25+",
  menuStats__projectsHint:
    "25 are full-fledged projects. The “+” is all the small stuff that only nominally counts as projects.",
  menuStats__reports: "Direct reports:",
  menuStats__reportsHint:
    "18 is how many people have worked under me over my career. 9 is the most at any one time.",
  menuStats__experience: "Experience: 14 years",
};

export { ruLocale__TopNavStats, enLocale__TopNavStats };
export type { localesKeys__TopNavStats };
